<template>
  <b-form @submit.prevent="submit">
    <b-form-group
      id="serial-or-productnumber-label"
      :label="$t('serialnumberOrProductNumber')"
      label-for="serial-or-productnumber"
    >
      <b-form-input
        id="serial-or-productnumber"
        v-model="form.serial"
        type="text"
        :placeholder="$t('serialOrPn')"
        required
      ></b-form-input>
    </b-form-group>

    <p v-if="processingProduct"><i class="fas fa-spinner fa-spin"></i></p>
    <p v-if="form.serial.length > 0 && !productDetails.length">
      {{ $t("noProductFound") }}
    </p>

    <div v-if="productDetails.length">
      <b-table :items="productDetails"></b-table>

      <b-row>
        <b-col v-if="statusEnabled.left" md="6" class="p-0">
          <b-form-group
            id="status-l-label"
            :label="$t('statusLeftProduct')"
            label-for="status-l"
          >
            <b-form-select
              id="status-l"
              v-model="fittestForm.lfc"
              text-field="key"
              required
              :options="options"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col v-if="statusEnabled.right" md="6" class="p-0">
          <b-form-group
            id="status-r-label"
            :label="$t('statusRightProduct')"
            label-for="status-r"
            class="p-0"
          >
            <b-form-select
              id="status-r"
              v-model="fittestForm.rfc"
              text-field="key"
              required
              :options="options"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-form-group
          id="comment-label"
          :label="$t('comment')"
          label-for="comment"
        >
          <b-form-textarea
            id="comment"
            v-model="fittestForm.comment"
            placeholder=""
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </b-form-group>

        <b-col cols="12" class="p-0">
          <b-button v-if="!processing" type="submit" class="btn btn-default">{{
            $t("submit2")
          }}</b-button>
          <b-button v-if="processing" class="mt-3" block disabled
            ><i class="fas fa-spinner fa-spin"></i
          ></b-button>
        </b-col>
      </b-row>
    </div>
  </b-form>
</template>

<script>
import {
  BForm,
  BFormInput,
  BFormGroup,
  BTable,
  BFormSelect,
  BButton,
  BRow,
  BCol,
  BFormTextarea,
} from "bootstrap-vue"
import { getProduct } from "@/services/product"
import {
  getOptions,
  submitFunctionControl,
} from "@/services/product/functioncontrol"

export default {
  components: {
    BForm,
    BFormInput,
    BFormGroup,
    BTable,
    BFormSelect,
    BButton,
    BRow,
    BCol,
    BFormTextarea,
  },
  data: function () {
    return {
      form: {
        serial: "",
      },
      fittestForm: {
        productID: "",
        lfc: null,
        rfc: null,
        comment: "",
        dimensionObjectID: null,
      },
      options: [],
      product: null,
      processingProduct: false,
      processWhenAvailable: null,
      processing: false,
    }
  },
  computed: {
    serial: function () {
      return this.form.serial
    },
    productDetails: function () {
      if (!this.product?.item || this.product?.Error) return []
      const details = [
        {
          Company: this.product.customer.companyName,
          Item: this.product.item.description,
          serial: this.product.serialID,
          productID: this.product.productID,
          L: this.product.l,
          R: this.product.r,
          firstname: this.product.person.firstname,
          lastname: this.product.person.lastname,
        },
      ]

      return details
    },
    statusEnabled: function () {
      return {
        left: this.product?.l, //this.item?.L,
        right: this.product?.r,
      }
    },
    message: function () {
      if (!this.product) return ""
      const p = this.product

      return `<strong>${p.serialID} - ${p.productID}</strong><br> ${p.Item.description} - ${p.Person.firstname} ${p.Person.lastname} ${p.Person.birthDate}`
    },
    customerID: function () {
      return this.$store.state.customerID
    },
  },
  watch: {
    serial: function (value) {
      if (value.length) this.getProductFromSerialID(value)
    },
    product: function (product) {
      this.fittestForm.productID = product?.productID ?? null
      this.fittestForm.dimensionObjectID = product?.person.dimensionObjectID
    },
  },
  created: async function () {
    this.options = await getOptions()
    this.options.unshift({ value: null, key: "Please select an option" })

    const customerField = document.getElementsByName("customerid")

    this.$store.commit("setCustomerID", { customerID: customerField[0].value })
  },
  methods: {
    getProductFromSerialID: async function (serialID) {
      if (this.processingProduct) {
        this.processWhenAvailable = serialID
        return
      }

      this.processingProduct = true

      do {
        const serialIDToProcess = this.processWhenAvailable ?? serialID
        this.processWhenAvailable = null
        this.product = await this.fetchProduct(serialIDToProcess)
      } while (this.processWhenAvailable)

      this.processingProduct = false
    },
    fetchProduct: async function (serialID) {
      return await getProduct(serialID)
    },
    submit: async function () {
      if (this.processing || this.form.serial.length < 1) return

      this.processing = true

      if (this.customerID != "") {
        this.fittestForm.audicienCustomerID = this.customerID
      }

      this.fittestForm.customerID = this.product.customer.customerID
      const result = await submitFunctionControl(this.fittestForm)

      this.processing = false
      this.$toasted.show(result.data.message)
      this.clearData()
    },
    clearData: function () {
      this.fittestForm.productID = ""
      this.product = null
    },
  },
}
</script>

<style lang="scss">
#fittestPanel {
  .form-group {
    padding: 0px;
  }
  textarea {
    border-radius: 0px;
  }
}
</style>
